import {
    LOG_OUT, PTO_SETTING, PTO_TYPE_GET_LIST, PTO_TYPE_CREATE, PTO_TYPE_DELETE, PTO_TYPE_UPDATE,
    PTO_REASON_CREATE, PTO_REASON_DELETE, PTO_REASON_GET_LIST, PTO_REASON_UPDATE,
    HOLIDAY_CREATE, HOLIDAY_UPDATE, HOLIDAY_DELETE, HOLIDAY_GET_LIST, 
    TIMEOFF_REQUEST_LIST, CREATE_TIMEOFF_REQUEST, USER_PTO_INFO_LIST,
    MODIFY_TIMEOFF_REQUEST, DELETE_TIMEOFF_REQUEST, STAFF_PTO_INFO,
    GET_PENDING_REQUESTS, GET_PENDING_REQUEST_DATA, UPDATE_PENDING_REQUESTS, 
    LEAVE_LIST, USER_REQUEST_LIST, ASSIGNED_HOLIDAY_GET_LIST,
    HOLIDAY_CREATE_ASSIGNMENT, HOLIDAY_UPDATE_ASSIGNMENT,
    STAFF_ALLOWED_LIST, UPDATE_STAFF_ALLOWED_LIST, 
    GET_BLACKOUT_DAY_LIST, POST_BLACKOUT_DAY, UPDATE_BLACKOUT_DAY, DELETE_BLACKOUT_DAY,
    BIRTHDAY_LIST
} from "./ActionTypes";
import PTOServices from "../services/PTOServices";
import {getUser} from "../utils/TokenManager";


export const ptoSetting = (locationId, settingObj={}, year, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getPTOSetting(locationId, year);
            } else {
                result = await PTOServices.savePTOSetting(locationId, settingObj, year);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_SETTING, settings: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getPTOTypeList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getPTOTypeList(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_TYPE_GET_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const createPTOType = (locationId, ptoTypeObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.createPTOType(locationId, ptoTypeObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            console.log(result)
            if (201 === result.status) {
                dispatch({type: PTO_TYPE_CREATE, ptoTypeObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updatePTOType = (ptoTypeObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.updatePTOType(ptoTypeObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_TYPE_UPDATE, ptoTypeObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deletePTOType = (ptoTypeObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.deletePTOType(ptoTypeObj.id);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_TYPE_DELETE, ptoTypeId: ptoTypeObj.id});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getPTOReasonList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getPTOReasonList(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_REASON_GET_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const createPTOReason = (locationId, ptoReasonObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.createPTOReason(locationId, ptoReasonObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (201 === result.status) {
                dispatch({type: PTO_REASON_CREATE, ptoReasonObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updatePTOReason = (ptoReasonObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.updatePTOReason(ptoReasonObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_REASON_UPDATE, ptoReasonObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deletePTOReason = (ptoReasonObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.deletePTOReason(ptoReasonObj.id);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: PTO_REASON_DELETE, ptoReasonId: ptoReasonObj.id});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getHolidayList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getHolidayList(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: HOLIDAY_GET_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getAssignedHolidayList = (settingId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getAssignedHolidayList(settingId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: ASSIGNED_HOLIDAY_GET_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const CreateHolidayAssignment = (settingId, holidayObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.CreateAssignedHoliday(settingId, holidayObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (201 === result.status) {
                dispatch({type: HOLIDAY_CREATE_ASSIGNMENT, holidayObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateHolidayAssignment = (holidayObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.UpdateAssignedHoliday(holidayObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: HOLIDAY_UPDATE_ASSIGNMENT, holidayObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const AddHoliday = (locationId, holidayObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.AddHoliday(locationId, holidayObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (201 === result.status) {
                dispatch({type: HOLIDAY_CREATE, holidayObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateHoliday = (holidayObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.updateHoliday(holidayObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: HOLIDAY_UPDATE, holidayObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deleteHoliday = (holidayId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.deleteHoliday(holidayId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: HOLIDAY_DELETE, holidayId});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getTimeOffList = (userId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getTimeOffList(userId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: TIMEOFF_REQUEST_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const TimeOffRequest = (requestObj, action="POST") => (
    async (dispatch) => {
        try {
            let result = {};
            if (action === "POST") {
                result = await PTOServices.createTimeOffRequest(requestObj);
            } else if (action === "PUT") {
                result = await PTOServices.modifyTimeOffRequest(requestObj);
            } else if (action === "DELETE") {
                result = await PTOServices.deleteTimeOffRequest(requestObj.id);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (action === "POST" && 201 === result.status) {
                dispatch({type: CREATE_TIMEOFF_REQUEST, requestObj: result.data});
                return true;
            } else if (action === "PUT" && 200 === result.status) {
                dispatch({type: MODIFY_TIMEOFF_REQUEST, requestObj: result.data});
                return true;
            } else if (action === "DELETE" && 200 === result.status) {
                dispatch({type: DELETE_TIMEOFF_REQUEST, requestId: requestObj.id});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getPendingRequest = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getPendingRequests(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: GET_PENDING_REQUESTS, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getPendingRequestData = (requestId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getPendingRequestData(requestId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: GET_PENDING_REQUEST_DATA, requestObj: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updatePendingRequestData = (requestObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.updatePendingRequestData(requestObj);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: UPDATE_PENDING_REQUESTS, requestObj: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const userPTOInfo = (locationId, infoList=[], year, method="GET") => (
    async (dispatch) => {
        try {
            let result;
            if (method === "PUT") {
                result = await PTOServices.updateUsedPTOInfo(locationId, infoList);
            } else {
                result = await PTOServices.getUserPTOInfo(locationId, year);
            }
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: USER_PTO_INFO_LIST, list: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getStaffPTOInfo = () => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getStaffPTOInfo();
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: STAFF_PTO_INFO, data: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getLeaveList = (year) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getLeaveList(year);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: LEAVE_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getBirthdayList = (year) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getBirthdayList(year);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: BIRTHDAY_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getUserRequests = (userId, year) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getUserRequests(userId, year);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: USER_REQUEST_LIST, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getUserList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getUserList(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data.user;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const individualPTOSetting = (ptoSettingId, userId, settingObj={}, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getIndividualPTOSetting(
                    ptoSettingId, userId
                );
            } else if (method === "PUT") {
                result = await PTOServices.updateIndividualPTOSetting(
                    ptoSettingId, userId, settingObj
                );
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status || 201 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const updateIndividualPTOSetting = (settingObj) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.updateIndividualPTOSetting(settingObj);
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getListOfstaffAllowed = (settingId) => (
    async (dispatch) => {
        try {
            let result = await PTOServices.getListOfStaffAllowed(settingId);
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: STAFF_ALLOWED_LIST, list: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const staffAllowedSetting = (obj, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getStaffAllowed(obj.id);
            } else if (method === "PUT") {
                result = await PTOServices.updateStaffAllowed(obj);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: UPDATE_STAFF_ALLOWED_LIST, obj: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const experienceSetting = (
    objList, ptoSettingId, jobTitleId, copyToAll=false, method="GET"
) => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getExperienceRange(ptoSettingId, jobTitleId);
            } else if (method === "PUT") {
                result = await PTOServices.updateExperienceRange(
                    objList, ptoSettingId, jobTitleId, copyToAll
                );
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getJobTitleList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await PTOServices.getJobTitle(locationId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data.job_title;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const overridePTOSetting = (userId, userSetting, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getOverrideSetting(userId);
            } else if (method === "PUT") {
                result = await PTOServices.updateOverrideSetting(userId, userSetting);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const userProbationSetting = (userId, userSetting, method="GET") => (
    async (dispatch) => {
        try {
            let result = {};
            if (method === "GET") {
                result = await PTOServices.getUserProbationSetting(userId);
            } else if (method === "PUT") {
                result = await PTOServices.updateUserProbationSetting(userId, userSetting);
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const blackoutDayAction = (action={}) => (
    async (dispatch) => {
        try {
            let result = {};
            switch (action.type) {
                case GET_BLACKOUT_DAY_LIST: {
                    result =  await PTOServices.getBlackoutDayList(action.locationId);
                    break;
                }
                case POST_BLACKOUT_DAY: {
                    result =  await PTOServices.AddBlackoutDay(
                        action.locationId, action.blackoutDayObj
                    );
                    break;
                }
                case UPDATE_BLACKOUT_DAY: {
                    result =  await PTOServices.updateBlackoutDay(action.blackoutDayObj);
                    break;
                }
                case DELETE_BLACKOUT_DAY: {
                    result =  await PTOServices.deleteBlackoutDay(action.blackoutDayId);
                    break;
                }
            }
            
            if (result.headers && getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status || 201 === result.status) {
                dispatch({...action, response: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);




// WEBPACK FOOTER //
// ./src/actions/PTOAction.js